// If there are 18 or more eligible materials, only show the first 18. If there
// are less than 18 eligible materials, only show the first 9.
const trimPopularMaterialsArray = materials =>
  materials.slice(0, materials.length >= 18 ? 18 : 9);

export default trimPopularMaterialsArray;
